import React from "react";
import { AuthError } from "@azure/msal-browser";
import { Row, Col, Space, Typography, Result } from "antd";

export const AuthenticationError: React.FC<{ error: AuthError | null }> = ({
  children,
  error,
}) => (
  <Row justify="center" align="middle" style={{ height: "100vh" }}>
    <Col>
      <Result
        status="warning"
        title="Error logging you in"
        extra={
          error ? (
            <Space direction="vertical">
              <Typography.Text>{error.errorMessage}</Typography.Text>
              <Typography.Text>{error.subError}</Typography.Text>
            </Space>
          ) : (
            <>{children}</>
          )
        }
      />
    </Col>
  </Row>
);
